module.exports = __webpack_public_path__ + "static/img/taschenmesser.932c3d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taschenmesser.jpg
// module id = 303
// module chunks = 0